import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Plus, Building } from "lucide-react";
import "./Client.css";

const url = process.env.REACT_APP_BACKEND_URL;

const Client = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    location: "",
    manager_name: "",
    manager_contact: "",
    no_of_capacity: "",
    salary: "",
    note: ""
  });

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const onSubmitHandler = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.post(`${url}/api/client`, data);

      if (response.data.success) {
        toast.success("Client added successfully");
        navigate("/ViewClient");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="client-form-container">
        <h2 className="form-title">
          <Building size={20} /> Add Client
        </h2>

        <div className="header">
          <button onClick={() => navigate('/ViewClient')} className="add-button">
            <Plus size={16} /> View Client
          </button>
        </div>

        <form className="client-form" onSubmit={onSubmitHandler}>
          <input
            type="text"
            name="name"
            placeholder="Client Name"
            value={data.name}
            onChange={onChangeHandler}
            required
          />

          <input
            type="text"
            name="location"
            placeholder="Location"
            value={data.location}
            onChange={onChangeHandler}
          />

          <input
            type="text"
            name="manager_name"
            placeholder="Manager Name"
            value={data.manager_name}
            onChange={onChangeHandler}
          />

          <input
            type="tel"
            name="manager_contact"
            placeholder="Manager Contact"
            value={data.manager_contact}
            onChange={onChangeHandler}
          />

          <input
            type="number"
            name="no_of_capacity"
            placeholder="No of Capacity"
            value={data.no_of_capacity}
            onChange={onChangeHandler}
          />

          <input
            type="number"
            name="salary"
            placeholder="Salary"
            value={data.salary}
            onChange={onChangeHandler}
          />

          <textarea
            name="note"
            placeholder="Note (optional)"
            value={data.note}
            onChange={onChangeHandler}
            rows="3"
          />

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Adding..." : "Add Client"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Client;